// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"233c92b8","455":"d8b19409","977":"9eb781aa"}[chunkId] + ".chunk.js";
};